import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ReadService } from './read.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { IServiceFeeType } from '../interfaces/service-fee';

@Injectable({ providedIn: 'root' })
export class ServiceFeeTypeService extends ReadService<any, any> {
  url = '/api/service-fee-type';
  entityTitle = 'Service Fee Type';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public getAll(): Promise<IServiceFeeType[]> {
    return this.http
      .get(`${this.url}/all`, { headers: new HttpHeaders({}) })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public create(dto: IServiceFeeType) {
    const url = `${this.url}`;
    return this.handleRequest<number>(
      this.http.post<number>(url, dto),
      this.handlersFactory.getForCreate(this.entityTitle),
    );
  }

  public update(id: number, dto: IServiceFeeType) {
    const url = `${this.url}/${id}`;
    return this.handleRequest<number>(
      this.http.put<number>(url, dto),
      this.handlersFactory.getForUpdate(this.entityTitle),
    );
  }

  public delete(id: number) {
    const url = `${this.url}/${id}`;
    return this.handleRequest<boolean>(
      this.http.delete<boolean>(url),
      this.handlersFactory.getForDelete(this.entityTitle),
    );
  }
}
